import { formatLocationTime } from "@/lib/location-time";
import { usePage } from "@inertiajs/react";

export function LocationTime({
  value,
  dateStyle,
  timeStyle,
}: {
  value: string;
  dateStyle?: Intl.DateTimeFormatOptions["dateStyle"];
  timeStyle?: Intl.DateTimeFormatOptions["timeStyle"];
}) {
  const context = usePage().props.i18n;
  return (
    <time dateTime={value}>
      {formatLocationTime(value, context, { dateStyle, timeStyle })}
    </time>
  );
}
